import React, { useEffect, useState } from 'react';
import './style.css';

const ApplePayError = ({ errorType, onClose }) => {
  const [visible, setVisible] = useState(false);
  
  // Log detailed information when the error appears
  useEffect(() => {
    // Create a unique error ID for tracing
    const errorId = `error-${Date.now()}-${Math.random().toString(36).substring(2, 8)}`;
    const orderId = localStorage.getItem("orderId");
    const paymentStartTime = sessionStorage.getItem("applePayStartTime");
    const elapsedTime = paymentStartTime ? 
      Math.floor((Date.now() - parseInt(paymentStartTime)) / 1000) : 'unknown';
    
    // Capture detailed state information
    const stateInfo = {
      orderId,
      errorType,
      errorId,
      timestamp: new Date().toISOString(),
      paymentStartTime: paymentStartTime ? new Date(parseInt(paymentStartTime)).toISOString() : 'unknown',
      elapsedSeconds: elapsedTime,
      // Capture success flags
      successFlags: {
        windowFlag: !!window.successfulPaymentReceived,
        sessionStorageFlag: sessionStorage.getItem('successfulPaymentReceived') === 'true',
        navigatingFlag: window.isNavigatingToSuccessPage || sessionStorage.getItem('isNavigatingToSuccessPage') === 'true'
      },
      // Capture storage state
      sessionStorage: Object.keys(sessionStorage).reduce((acc, key) => {
        acc[key] = sessionStorage.getItem(key);
        return acc;
      }, {}),
      localStorage: Object.keys(localStorage).reduce((acc, key) => {
        acc[key] = localStorage.getItem(key);
        return acc;
      }, {}),
      // Capture browser info
      browserInfo: {
        userAgent: navigator.userAgent,
        language: navigator.language,
        onLine: navigator.onLine,
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
      }
    };
    
    // Standard log for debugging
    console.log(`[ApplePayError ${errorId}] Error notification displayed`, stateInfo);
    
    // Visually distinctive log for quick identification
    console.warn(`%c🛑 APPLE PAY ERROR SHOWN: ${errorType} [ID: ${errorId}]`, 
      'background: #ffdddd; color: #ff0000; font-size: 14px; font-weight: bold; padding: 4px;');
    
    // Log to console in a grouped format for better organization
    console.group(`%c🛑 ApplePay Error Details [${errorId}]`, 'color: #ff0000; font-weight: bold;');
    console.log('Error Type:', errorType);
    console.log('Order ID:', orderId || 'Not available');
    console.log('Payment Duration:', `${elapsedTime} seconds`);
    console.log('Success Flags:', stateInfo.successFlags);
    console.log('Full State:', stateInfo);
    console.groupEnd();
    
    // Store error info in sessionStorage for potential later analysis
    try {
      sessionStorage.setItem('lastApplePayError', JSON.stringify({
        errorType,
        errorId,
        timestamp: new Date().toISOString(),
        orderId
      }));
    } catch (e) {
      console.error('Failed to store error info in sessionStorage:', e);
    }
    
    // Animate in
    setVisible(true);
    
    // Auto-close after 5 seconds
    const timer = setTimeout(() => {
      setVisible(false);
      setTimeout(onClose, 500); // Call onClose after fade out animation
    }, 5000);
    
    return () => clearTimeout(timer);
  }, [errorType, onClose]);
  
  // Different error messages based on error type
  const getErrorMessage = () => {
    switch(errorType) {
      case 'script_loading':
        return "שגיאה בטעינת מערכת התשלומים";
      case 'payment_processing':
        return "שגיאה בעיבוד התשלום";
      case 'timeout':
        return "פג הזמן לביצוע התשלום";
      case 'order_status':
        return "שגיאה בעדכון סטטוס ההזמנה";
      default:
        return "שגיאה בתהליך התשלום";
    }
  };
  
  return (
    <div className={`applepay-error-notification ${visible ? 'visible' : ''}`}>
      {getErrorMessage()}
    </div>
  );
};

export default ApplePayError;
